export default {
  h1_services: "Serviços de inteligência artificial para médicos",
  Services: "Serviços",
  eduServices: "Cursos",
  AIServices: "Serviços",
  mg: "Mamografia",
  dx: "Radiografia de tórax \n e fluorografia",
  // rf: "Radiografias",
  "Go to service": "Acessar",
  "Service banner text":
    "Calcule o impacto da implementação da inteligência artificial na sua instituição",
  Calc: "Calcular",
  "Services title": "Lista de serviços | " + process.env.VUE_APP_INSTALL_NAME,
  "No description service": "Descrição não fornecida",
  "Services cannot loading":
    "Serviço temporariamente indisponível. Tente mais tarde",
  "Cash calc title":
    "Cálculo de economia | " + process.env.VUE_APP_INSTALL_NAME,
  "Cash calc": "Cálculo de economia",
  "Cash calc desc": "Quantos recursos você pode economizar com IA",
  "Cash calc desc about":
    "Insira os dados da sua instituição. Após sair da calculadora, os dados serão apagados.",
  "Average cash": "Salário médio mensal de um radiologista",
  "Study calc count": "Número de exames por mês na sua instituição",
  mmg: "Mamografia",
  ddx: "Radiografia de tórax",
  ct: "TC de tórax",
  "Start calc": "Calcular",
  economy: "Economia",
  rub: " rub.",
  "calc time": " h",
  "Calc summary": "Total por ano",
  "Without AI": "Sem inteligência artificial",
  "With AI": "Com inteligência artificial",
  "Count calc short": "Qtd ",
  "Calc in Year": " por ano",
  "Calc item 1": "Descrição de <br /> 1 exame, min",
  "Calc item 2": "Custo da descrição de <br />1 exame, rub",
  "Calc item 3": "Gastos com <br />descrição",
  "Calc item 4": "Tempo para <br />descrição, h",
  mmg__count: "MMG",
  ddx__count: "RX/FLG",
  ct__count: "TC",
  "Calc info": "Metodologia de cálculo",
};
